export default {
  email: {
    displayName: 'Email',
  },
  twilio: {
    displayName: 'SMS',
  },
  pushbullet: {
    displayName: 'Pushbullet',
  },
  discord: {
    displayName: 'Discord',
  },
  telegram: {
    displayName: 'Telegram',
  },
  pushover: {
    displayName: 'Pushover',
  },
  slack: {
    displayName: 'Slack',
  },
}
